import { CarrierPage } from "./CarrierAssemblyPage";

const CarrierAssembly = () => {
	return <CarrierPage />;
};
export default CarrierAssembly;
